import type {
  WorkflowOverviewGroup,
  WorkflowOverviewItem,
  WorkflowOverviewItemType,
} from '@app/application/workflow-overview-navigation/types'

import SFetch from '@app/utils/sfetch'

export function getOverview({
  filter,
  highlightedItemId,
  highlightedItemType,
  includeReviewStatus,
  workflowId,
  ledgerId,
}: {
  filter: string | null
  highlightedItemId?: number
  highlightedItemType?: WorkflowOverviewItemType
  includeReviewStatus: boolean
  ledgerId: number
  workflowId: number
}): Promise<void | Array<WorkflowOverviewItem | WorkflowOverviewGroup> | null> {
  const url = window.Silverfin.Routes.overview_ledger_company_workflow_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId,
    ledgerId,
    workflowId,
    {
      filter,
      highlighted_item_id: highlightedItemId,
      highlighted_item_type: highlightedItemType,
      include_review_status: includeReviewStatus,
    }
  )

  return SFetch.jsonWithAlert<
    Array<WorkflowOverviewItem | WorkflowOverviewGroup>
  >(url)
}
